import { AgingReportDto, AgingReportFilterReqDto, AgingStatusDto, UpdateAgingStateRequest } from "../../interfaces/agingReport/agingReport";
import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";

export async function getAgingReportAsync(
    request: AgingReportFilterReqDto,
    userid : string,
    authToken: string,
    minAgingDays?: number | null
): Promise<ApiResponse<PagedResults<AgingReportDto>>> {

    const params = new URLSearchParams();

    if (request.regionIds)
        request.regionIds.forEach(id => params.append("RegionIds", id.toString()));

    if (request.waiverIds)
        request.waiverIds.forEach(id => params.append("WaiverIds", id.toString()));

    if (request.statusId !== null)
        params.append("StatusId", request.statusId.toString());

    if (minAgingDays !== null && minAgingDays !== undefined)
        params.append("MinAgingDays", minAgingDays.toString());

    params.append("PageNumber", request.pageNumber.toString());
    params.append("PageSize", request.pageSize.toString());

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/aging-report/${userid}/aging-report?${params.toString()}`;

    const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    });

    return await response.json();
}

export async function UpdateAgingStateAsync(
    request: UpdateAgingStateRequest,
    participantId: number,
    authToken: string
): Promise<ApiResponse<PagedResults<AgingReportDto>>> {

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/aging-report/${participantId}/UpdateAgingState`;

    const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request)
    });

    return await response.json();
}

export async function GetAgingStatusesAsync(
    authToken: string
): Promise<ApiResponse<AgingStatusDto[]>> {

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/aging-report/statuses`;

    const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authToken}`,
        }
    });

    return await response.json();
}

export async function downloadAgingReportPdf(
    request: AgingReportFilterReqDto,
    authToken: string
) {
    const params = new URLSearchParams();

    if (request.regionIds)
        request.regionIds.forEach(id => params.append("RegionIds", id.toString()));

    if (request.waiverIds)
        request.waiverIds.forEach(id => params.append("WaiverIds", id.toString()));

    if (request.statusId !== null && request.statusId !== undefined)
        params.append("StatusId", request.statusId.toString());

    params.append("PageNumber", request.pageNumber.toString());
    params.append("PageSize", request.pageSize.toString());

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/aging-report/participant-aging/pdf?${params.toString()}`;

    const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authToken}`,
        }
    });

    if (!response.ok) {
        throw new Error("Failed to download PDF");
    }

    const blob = await response.blob();
    return blob;
}


